//TODO (3.0): This should be moved to a new plugin (plaudit-analytics)
//TODO (3.0): Consider converting this to a pair of files
declare global {
	interface Window {
		registerPlauditBaseAnalyticsProvider(analyticsProvider: AnalyticsProvider): void;
		injectTrackerScript(src: string, pos: 'first'|'last'): void;
		cmplz_has_consent?(category: string): boolean;
		analyticsIntegrationConfig?: {mechanism: 'native'|'complianz'};
		clarityMS?: {projectId: string, categories?: string[]};
		facebookPixel?: {projectId: string, categories?: string[]};
		linkedInInsightTag?: {partnerId: string, categories?: string[]};
		zoomInfo?: {projectKey: string, categories?: string[]};
	}
}

export type AnalyticsProvider = {name: string, categories?: string[], activate(): void};
const analyticsProviders: (Required<Omit<AnalyticsProvider, 'prep'>>&{active: boolean})[] = [];
export function registerPlauditBaseAnalyticsProvider(analyticsProvider: AnalyticsProvider) {
	const analyticsProviderInstance = {
		active: false,
		...analyticsProvider,
		categories: analyticsProvider.categories ?? ['marketing', 'statistics']
	};
	analyticsProviders.push(analyticsProviderInstance);

	// The rest of this function accounts for potential late startups
	if (window.analyticsIntegrationConfig?.mechanism === 'complianz') {
		if (window.cmplz_has_consent && analyticsProviderInstance.categories.every(cat => window.cmplz_has_consent!(cat))) {
			analyticsProviderInstance.active = true;
			analyticsProviderInstance.activate();
		}
	} else if ((navigator.doNotTrack !== '1' && !(navigator as any).globalPrivacyControl) || window.location.search.includes("analytics-test")) {
		analyticsProviderInstance.active = true;
		analyticsProviderInstance.activate();
	}
}
window.registerPlauditBaseAnalyticsProvider = registerPlauditBaseAnalyticsProvider;

export function injectTrackerScript(src: string, pos: 'first'|'last') {
	const trackerScript = document.createElement("script");
	trackerScript.type = "text/javascript";
	trackerScript.async = true;
	trackerScript.src = src;
	switch (pos) {
		case 'first':
			const firstScript = document.getElementsByTagName("script")[0];
			(firstScript ?? document.head.firstElementChild).before(trackerScript);
			break;
		case 'last':
			document.body.appendChild(trackerScript);
			break;
		default:
			console.trace(`Encountered an invalid TrackerScriptPosition (${pos}) for`, src);
			return injectTrackerScript(src, 'first');
	}
}
window.injectTrackerScript = injectTrackerScript;

if (window.clarityMS) {
	registerPlauditBaseAnalyticsProvider({
		name: 'Clarity MS',
		categories: window.clarityMS.categories,
		activate() {
			injectTrackerScript(`https://www.clarity.ms/tag/${window.clarityMS!.projectId}`, 'first');
		}
	});
}

if (window.facebookPixel) {
	registerPlauditBaseAnalyticsProvider({
		name: 'Facebook Pixel',
		categories: window.facebookPixel.categories,
		activate() {
			injectTrackerScript("https://connect.facebook.net/en_US/fbevents.js", 'first');
		}
	});
}

if (window.linkedInInsightTag) {
	registerPlauditBaseAnalyticsProvider({
		name: 'LinkedIn Insight Tag',
		categories: window.linkedInInsightTag.categories,
		activate() {
			((window as any)._linkedin_data_partner_ids||((window as any)._linkedin_data_partner_ids=[])).push(window.linkedInInsightTag!.partnerId);
			injectTrackerScript("https://snap.licdn.com/li.lms-analytics/insight.min.js", 'first');
		}
	});
}

if (window.zoomInfo) {
	registerPlauditBaseAnalyticsProvider({
		name: 'ZoomInfo',
		categories: window.zoomInfo.categories,
		activate() {
			(window as any).ZIProjectKey = window.zoomInfo!.projectKey;
			injectTrackerScript("https://js.zi-scripts.com/zi-tag.js", 'last');
		}
	});
}

if (window.analyticsIntegrationConfig?.mechanism === 'complianz') {
	const onCmplzPreferencesChange = () => {
		for (const analyticsProvider of analyticsProviders) {
			if (analyticsProvider.categories.every(cat => window.cmplz_has_consent!(cat))) {
				if (!analyticsProvider.active) {
					analyticsProvider.active = true;
					analyticsProvider.activate();
				}
			} else if (analyticsProvider.active) {
				analyticsProvider.active = false;
				window.location.reload();
			}
		}
	}
	if (window.cmplz_has_consent) {
		onCmplzPreferencesChange();
	}
	document.addEventListener('cmplz_run_after_all_scripts', () => onCmplzPreferencesChange());
	document.addEventListener('cmplz_status_change', () => onCmplzPreferencesChange());
} else {
	document.addEventListener('DOMContentLoaded', () => {
		if (navigator.doNotTrack !== '1' && !(navigator as any).globalPrivacyControl) {
			for (const blocked of document.querySelectorAll<HTMLScriptElement>("script[data-category][type='text/plain']")) {
				const script = document.createElement("script");
				for (const attr of blocked.attributes) {
					if (attr.name === "data-src") {
						script.setAttribute("src", attr.value);
					} else if (attr.name !== "type") {
						script.setAttributeNode(attr.cloneNode() as Attr);
					}
				}
				if (!blocked.hasAttribute("data-src")) {
					script.text = blocked.text;
				}
				blocked.before(script);
				blocked.remove();
			}
			for (const analyticsProvider of analyticsProviders) {
				if (!analyticsProvider.active) {
					analyticsProvider.active = true;
					analyticsProvider.activate();
				}
			}
		}
	});
}
